<p-toast />

<div class="mb-3">
  <p-checkbox
    label="{{ 'workflow.variables.import.override' | translate }}"
    [binary]="true"
    [(ngModel)]="override"
  ></p-checkbox>
</div>

<p-fileUpload
  #fileUpload
  name="variablesImportFile"
  accept="application/json"
  [fileLimit]="1"
  [customUpload]="true"
  (uploadHandler)="onUpload($event)"
  (onError)="onError($event)"
>
  <ng-template let-file pTemplate="file">
    <div class="p-fileupload-row">
      <div class="p-fileupload-filename">{{ file.name }}</div>
      <div>{{ fileUpload.formatSize(file.size) }}</div>
    </div>
  </ng-template>
</p-fileUpload>
